import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { Observable } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { RecipeFormValues } from '../../../retail-specification/models/form-values';
import { SpecFieldNames } from '../../../specification/constants/specification-field-names.enum';
import { getRmsRecipeSpecifications } from '../../selectors';

const isAttachedToMasterItem = (mapItem: RecipeFormValues, recipe: RecipeFormValues[]) => {
  return _safe(() => mapItem.id === recipe[0].id, false);
};

export namespace MasterDateBlocker {
  export class MasterDateOnly extends BaseAsyncValue<boolean> {
    private buffer = {
      lastFormSize: 0,
    };

    getValue(): Observable<boolean> {
      return this.store.select(getRmsRecipeSpecifications).pipe(
        takeUntil(this.ngDestroy),
        filter((recipe) => recipe.length !== this.buffer.lastFormSize),
        tap((recipe) => (this.buffer.lastFormSize = recipe.length)),
        map((recipe) => {
          if (isAttachedToMasterItem(this.mapItem, recipe)) {
            return false;
          } else {
            return true;
          }
        }),
      );
    }
  }

  export class UniqueDate extends BaseAsyncValue<Date> {
    private buffer = {
      lastFormSize: 0,
      lastMasterDate: undefined,
    };

    getValue(...args: any[]): Observable<Date> {
      return this.store.select(getRmsRecipeSpecifications).pipe(
        takeUntil(this.ngDestroy),
        filter((recipe) => {
          const recipeSizeChanged = recipe.length !== this.buffer.lastFormSize;
          const masterDateChanged = recipe[0].values[SpecFieldNames.DATE] !== this.buffer.lastMasterDate;
          return recipeSizeChanged || masterDateChanged;
        }),
        tap((recipe) => {
          this.buffer.lastFormSize = recipe.length;
          this.buffer.lastMasterDate = recipe[0].values[SpecFieldNames.DATE];
        }),
        filter((recipe) => !isAttachedToMasterItem(this.mapItem, recipe)), // Only apply to non master item
        map((recipe) => {
          return recipe[0].values[SpecFieldNames.DATE];
        }),
      );
    }
  }

  export class UniqueTime extends BaseAsyncValue<Date> {
    private buffer = {
      lastFormSize: 0,
      lastMasterTime: undefined,
    };

    getValue(...args: any[]): Observable<Date> {
      return this.store.select(getRmsRecipeSpecifications).pipe(
        takeUntil(this.ngDestroy),
        filter((recipe) => {
          if (!!recipe) {
            const recipeSizeChanged = recipe.length !== this.buffer.lastFormSize;
            const masterTimeChanged = recipe[0].values[SpecFieldNames.TIME] !== this.buffer.lastMasterTime;
            return recipeSizeChanged || masterTimeChanged;
          }
          return false;
        }),
        tap((recipe) => {
          this.buffer.lastFormSize = recipe.length;
          this.buffer.lastMasterTime = recipe[0].values[SpecFieldNames.TIME];
        }),
        filter((recipe) => !isAttachedToMasterItem(this.mapItem, recipe)), // Only apply to non master item
        map((recipe) => {
          return recipe[0].values[SpecFieldNames.TIME];
        }),
      );
    }
  }
}
